import { render, staticRenderFns } from "./SendGroupTable.vue?vue&type=template&id=777d6675"
import script from "./SendGroupTable.vue?vue&type=script&lang=js"
export * from "./SendGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports